import React from 'react';

// Components
import { FormattedMessage } from 'react-intl';
import { Button } from '@capintel/component-lib/button';
import { MenuToggle, PrimaryButton } from '@/views/components/buttons';
import { SearchInput } from '@/views/components/inputs';

// Libraries
import classNames from 'classnames';
import { Dropdown } from 'react-bootstrap';

// Hooks
import useScreenSize from '@/hooks/useScreenSize';

// Types
import { CurrentContact } from '@/redux/modules/types/contacts';

// Utils
import { formatMessage } from '@/utils/i18n';
import { truncateString } from '@/utils/objects';

type Props = {
  i18nBasePath: string;
  currentContact: CurrentContact;
  hasAccounts: boolean;
  setQuery: (query: string) => void;
  onGoToImportAccounts: () => void;
  onUnlinkContact: () => void;
};

export const ContactPlanAccountsHeader = ({ i18nBasePath, currentContact, hasAccounts, setQuery, onGoToImportAccounts, onUnlinkContact }: Props) => {
  const { isMobile } = useScreenSize();

  const renderOptions = () => {
    const menuItems = [
      {
        value: formatMessage(`${i18nBasePath}.UnlinkContact.Title`),
        icon: 'icon-ds-remove-circle-outline',
        className: 'destructive',
        onClick: onUnlinkContact,
      },
    ];

    return menuItems.map(item => (
      <Dropdown.Item key={item.value} role="menuitem" as="button" className={classNames(item.className)} onClick={() => item.onClick && item.onClick()}>
        <i className={item.icon} />
        <span>{item.value}</span>
      </Dropdown.Item>
    ));
  };

  return (
    <div className="contact-plan-accounts-header">
      <h3 className="contact-plan-accounts-header-title">
        <FormattedMessage id={`${i18nBasePath}.Header`} values={{ name: truncateString(currentContact?.contact?.fname ?? '', 80) }} />
      </h3>
      {hasAccounts ? (
        <div className="content-actions">
          <SearchInput className="search-input-v2" loading={false} placeholder={formatMessage(`${i18nBasePath}.SearchPlaceholder`)} onChange={setQuery} />
          <PrimaryButton className="primary-v2" icon="ds-file-upload" onClick={onGoToImportAccounts}>
            <FormattedMessage id={`${i18nBasePath}.ImportAccountsPrimaryButton`} />
          </PrimaryButton>
          {isMobile ? (
            <Button variant="secondary" onClick={onUnlinkContact} icon="remove-circle-outline">
              <FormattedMessage id={`${i18nBasePath}.UnlinkContact.Title`} />
            </Button>
          ) : (
            <div className="menu-options">
              <MenuToggle
                alignRight
                dataTestId="contactDetailsPlanAccounts-menuToggle-dropdownToggle"
                disabled={!currentContact.contact._id}
                options={renderOptions()}
              />
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};
